import type { Language } from '@offer-catalog/services/i18n'
import type { DdfsProductNature } from '@/api/ddfs/ddfs'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { fetchDdfsCollection } from '@/api/ddfs/ddfs'
import { queryKeys } from '@/query/queryKeys'
import { DataFallback } from './DataFallback'

export function ProductNature({ id }: Readonly<{ id?: string }>) {
  const { i18n, t } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language

  const { data, isError, isLoading } = useQuery({
    enabled: Boolean(Number(id)),
    queryKey: queryKeys.productNatures(id, currentLanguage),
    queryFn: async () => {
      return await fetchDdfsCollection<DdfsProductNature>('product_natures', { 'id[]': [id as string] }, currentLanguage)
    },
  })

  return (
    <div className="product-nature" data-testid="product_nature">
      <span className="sr-only">
        {t('products-page.filters.groups.product_natures')}
        :
        {' '}
      </span>
      <DataFallback
        value={data?.items}
        fallbackKey="products-page.product-card.no-product-nature"
        isLoading={isLoading && Boolean(id)}
        isError={isError}
        isEmpty={items => items.length === 0}
      >
        {items => items.map(item => item.name).join(', ')}
      </DataFallback>
    </div>
  )
}
